
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'Button',
  props: {
    type: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    ...mapGetters([
      'global'
    ])
  }
});
